import { render } from "./PanelAdminView.vue?vue&type=template&id=5975b590"
import script from "./PanelAdminView.vue?vue&type=script&lang=js"
export * from "./PanelAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__